var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 352.62,
    height: 352.62,
    style: {},
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "selected",
    opacity: 1,
    fill: "#fa4609",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.222,22.952c-15.912-8.568-33.66,7.956-44.064,17.748c-23.867,23.256-44.063,50.184-66.708,74.664   c-25.092,26.928-48.348,53.856-74.052,80.173c-14.688,14.688-30.6,30.6-40.392,48.96c-22.032-21.421-41.004-44.677-65.484-63.648   c-17.748-13.464-47.124-23.256-46.512,9.18c1.224,42.229,38.556,87.517,66.096,116.28c11.628,12.24,26.928,25.092,44.676,25.704   c21.42,1.224,43.452-24.48,56.304-38.556c22.645-24.48,41.005-52.021,61.812-77.112c26.928-33.048,54.468-65.485,80.784-99.145   C326.206,96.392,378.226,44.983,337.222,22.952z M26.937,187.581c-0.612,0-1.224,0-2.448,0.611   c-2.448-0.611-4.284-1.224-6.732-2.448l0,0C19.593,184.52,22.653,185.132,26.937,187.581z",
    id: "svg_2",
    opacity: 1,
    fill: "#fa4609",
    fillOpacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeCheckmark);
export default __webpack_public_path__ + "static/media/orangeCheckmark.159078bfc3253420ea72bf38468578f9.svg";
export { ForwardRef as ReactComponent };